module.exports = "@media print {\r\n    .list1{\r\n        display: none;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/schemes/schemes-menu/schemes-menu.component.css
// module id = ./src/app/schemes/schemes-menu/schemes-menu.component.css
// module chunks = main